module.exports = __webpack_public_path__ + "img/SEADOO.9ea3b81.jpg";